module.exports = __webpack_public_path__ + "img/trailerFrontLeft.4d0e56b4.svg";